import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CreateFertilizerPayload } from "../../../products/types";
import api from "../../http";
import { getApiErrorMessage, toApiError } from "../utils";
import { createFormData } from "../helpers/createFormdata";

export const usePostFertilizer = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (payload: CreateFertilizerPayload) => {
            try {
                const formData = createFormData(payload);
                return (await api.post(`/products/fertilizer/create`, formData)).data;
            } catch (error) {
                throw toApiError(error, 'Erro ao criar fertilizante');
            }
        },
        onSuccess: () => queryClient.invalidateQueries({ queryKey: ['fertilizers'] }),
        onError: error => console.error('Erro ao criar fertilizante:', getApiErrorMessage(error, 'Erro ao criar fertilizante'))
    });
};
